// @ts-nocheck
import React from 'react';
import { useLocation, useSearchParams, Outlet } from 'react-router-dom';
import useAuthentication from 'utils/useAuthentication';
import LoadingDimmer from './LoadingDimmer';

const ActionHandler = () => {
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();
    const { getRegisterUrl } = useAuthentication();

    const action = searchParams.get('action');

    if (action) {
        if (action === 'register') {
            searchParams.delete('action');
            const registerUrl = getRegisterUrl({ redirectPath: `${pathname}?${searchParams.toString()}` });
            window.location.assign(registerUrl);
            return <LoadingDimmer />;
        }
    }

    return <Outlet />;
};

export default ActionHandler;
